import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect',
  template: '',
})
export class RedirectComponent implements OnInit {
  ngOnInit(): void {
    window.location.href = 'https://uptal.blob.core.windows.net/uptal/other-assets/Company Profile Uptal .pdf';
  }
}
